import { render, staticRenderFns } from "./ReservationForm.vue?vue&type=template&id=0506207e&scoped=true"
import script from "./ReservationForm.vue?vue&type=script&lang=js"
export * from "./ReservationForm.vue?vue&type=script&lang=js"
import style0 from "./ReservationForm.vue?vue&type=style&index=0&id=0506207e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0506207e",
  null
  
)

export default component.exports